import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { ResponsiveLayout } from './components/ResponsiveLayout';
import ErrorBoundary from './components/ErrorBoundary';
import { LoadingDebug } from './components/LoadingDebug';
import { ResponsiveDashboard } from './components/ResponsiveDashboard';
import { ResponsiveEvents } from './components/ResponsiveEvents';
import { ResponsiveMembers } from './components/ResponsiveMembers';
import { MobileEventsTest } from './pages/MobileEventsTest';
import { MobileMembersTest } from './pages/MobileMembersTest';
import { MobileDashboardDebug } from './pages/MobileDashboardDebug';
import { MobileTest } from './pages/MobileTest';
import { SimpleTest } from './pages/SimpleTest';

import MemberProfile from './pages/member-profile';
import KioskPage from './pages/kiosk';
import { Donations } from './pages/donations';

import { Tasks } from './pages/tasks';
import { Automations } from './pages/automations';
import { Reports } from './pages/reports';
import { Settings } from './pages/settings';
import ChildrenCheckin from './pages/children-checkin';
import AddChild from './pages/add-child';
import EditChild from './pages/edit-child';
import { Login } from './pages/login';
import { Register } from './pages/register';
import { Invite } from './pages/invite';
import { Messaging } from './pages/messaging';
import ConversationView from './pages/ConversationView';
import AlertsPage from './pages/alerts';
import { AdminCenter } from './pages/admin-center';
import { Permissions } from './pages/permissions';
import { AIChat } from './pages/ai-chat';
import DonatePage from './pages/donate';
import DonateSuccess from './pages/donate/success';
import ManageSubscription from './pages/donate/manage-subscription';
import ManageDonations from './pages/donate/manage';

import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import ApprovalStatus from './components/ApprovalStatus';
import PrivacyPolicy from './pages/privacy-policy';
import { TermsOfService } from './pages/terms-of-service';
import PublicLayout from './components/PublicLayout';
import Landing from './pages/landing';
import PWAUpdateNotification from './components/PWAUpdateNotification';
import PWATest from './components/PWATest';

function App() {
  return (
    <ErrorBoundary>
      <Analytics />
      <SpeedInsights />
      <PWAUpdateNotification />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<PublicLayout><Landing /></PublicLayout>} />
        <Route path="/landing" element={<PublicLayout><Landing /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><Landing /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><Register /></PublicLayout>} />
        <Route path="/invite/:invitationId" element={<PublicLayout><Invite /></PublicLayout>} />
        <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
        <Route path="/terms-of-service" element={<PublicLayout><TermsOfService /></PublicLayout>} />
        <Route path="/conversation/:conversationId" element={<ConversationView />} />
                        <Route path="/donate/success" element={<DonateSuccess />} />
                <Route path="/donate/manage" element={<ManageDonations />} />
                <Route path="/donate/manage-subscription" element={<ManageSubscription />} />
                <Route path="/donate/:slug" element={<DonatePage />} />
        
        {/* Approval status route */}
        <Route path="/approval-status" element={<ApprovalStatus />} />
        
        {/* Protected routes */}
        <Route element={<ProtectedRoute><ResponsiveLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<ResponsiveDashboard />} />
          <Route path="/dashboard-debug" element={<MobileDashboardDebug />} />
          <Route path="/members" element={<ResponsiveMembers />} />
          <Route path="/members/:id" element={<MemberProfile />} />

          <Route path="/events" element={<ResponsiveEvents />} />
          <Route path="/events/:eventId" element={<ResponsiveEvents />} />
          <Route path="/events-test" element={<MobileEventsTest />} />
          <Route path="/members-test" element={<MobileMembersTest />} />
          <Route path="/mobile-test" element={<MobileTest />} />
          <Route path="/simple-test" element={<SimpleTest />} />
          <Route path="/donations" element={<Donations />} />

          <Route path="/tasks" element={<Tasks />} />
          <Route path="/automations" element={<Automations />} />
          <Route path="/children-check-in" element={<ChildrenCheckin />} />
          <Route path="/children-check-in/add" element={<AddChild />} />
          <Route path="/edit-child/:childId" element={<EditChild />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/ai-chat" element={<AIChat />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/permissions" element={<Permissions />} />
          <Route path="/messaging" element={<Messaging />} />
          <Route path="/sms" element={<Navigate to="/messaging" replace />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/pwa-test" element={<PWATest />} />
        </Route>
        
        {/* Kiosk route - standalone without layout */}
        <Route path="/kiosk" element={<ProtectedRoute><KioskPage /></ProtectedRoute>} />
        
        {/* System Admin only routes */}
        <Route path="/admin-center" element={<AdminRoute><AdminCenter /></AdminRoute>} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;